import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { DiseaseModel, DiseaseobjectModel } from '../HistoryModels/disease.model';
import { EMRService } from '../EMR.service';
import { PastHistoryModel } from '../HistoryModels/pasthistory.model';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { AuthService } from 'app/auth/auth.service';
import { HelplistService } from 'app/helplist.service';
import { Emr_delete_confirmation_boxComponent } from '../emr_delete_confirmation_box/emr_delete_confirmation_box.component';
import { DynamicHelpListComponent } from '../Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ExportService } from 'app/reports/services/export.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-NewDisease',
  templateUrl: './NewDisease.component.html',
  styleUrls: ['./NewDisease.component.scss']
})
export class NewDiseaseComponent implements OnInit {
  destroypast$: Subject<boolean> = new Subject<boolean>();
 private todaysdate = this.authService.getServerDate;
 private displayedColumns: string[] = ['diseasename', 'shortname','isdefault'];
 private dataSource = new MatTableDataSource<DiseaseModel>();
 private selectedrecoverydate: string;
 private selectstaredate: string;
 private durationvalue: any;
 private nextReviewUnit: string;
 private SearchDisease:any;
 private Diseaseobject:DiseaseobjectModel={};
 private  masterdisesAraaydata:any=[];
  applyFilter_grid(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  selectrow(row) {
    //console.log("row id: " + row.sequence)
    this.dashboardService.selectedRowIndex = row.pkDiseaseId;
    this.emrservice.pasthistory_added.diseaseName = row.diseaseName;
  }
 // lengthbackground;
 private selectedButton: number;
 private selectedButtonDuration: number;
 private selectedButton_value: number;
  // lengthbuttons: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09',
  //   '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24',
  //   '25', '26', '27', '28', '29', '30'];
//  lengthtimebuttons: string[] = ['D', 'W', 'M', 'Y'];
  // filteredOptions_diseases: Observable<DiseaseModel[]>;
  // DiseaseControl = new FormControl();
  private pasthistory_ds: MatTableDataSource<PastHistoryModel>
  private isrecoveryDate:boolean =false;
  //disease_ds = new MatTableDataSource<DiseaseModel>();
  //disease_ds: MatTableDataSource<DiseaseModel>
 // displayedColumns_diseaselist: string[] = ['select', 'diseaseName', 'shortName','isdefault'];
 private displayedColumns_pasthistory: string[] = ['diseasename', 'startdate', 'recoveron', 'remark', 'Action'];

  constructor(private dialog: MatDialog,
    private exportdata: ExportService,
    private emrservice: EMRService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private opdvisitService: OpdVisitService,
    private authService: AuthService,
    private helplistservice: HelplistService, private dialogRef: MatDialogRef<NewDiseaseComponent>
  ) {


    // for dieeases
    // this.filteredOptions_diseases = this.DiseaseControl.valueChanges
    //   .pipe(
    //     startWith(null),
    //     map(disease => disease ? this._filterdiseases(disease) : this.emrservice.diseaseList.slice())
    //   );
  }

  // private _filterdiseases(value: string): DiseaseModel[] {
  //   const filterValue = value.toLowerCase();

  //   return this.emrservice.diseaseList.filter
  //     (disease => disease.diseaseName.toLowerCase().indexOf(filterValue) === 0);

  //   //return this.authService.users.filter(ul => ul.userName.toLowerCase().indexOf(filterValue) === 0);
  // }
  stype:any;
  ngOnInit() {
    this.durationvalue = 0;
    this.nextReviewUnit='D';
    this.stype='S';
    this.emrservice.pasthistory_client = [];
    this.masterdisesAraaydata=[];
    //this.get_diseaselist();
    // this.disease_ds.data = this.emrservice.diseaseList;
    this.dataSource.data = this.helplistservice.diseaseList.filter(item=>item.isActive ==true);
    this.masterdisesAraaydata=this.helplistservice.diseaseList;
    this.pasthistory_ds = new MatTableDataSource(this.emrservice.pasthistory_client.slice());
    //console.log("d data " + this.disease_ds.data);
    this.dashboardService.selectedRowIndex = '';
    this.emrservice.pasthistory_added.startDate = null;
    this.emrservice.pasthistory_added.recoveryOn = null;
    this.emrservice.pasthistory_added.remarks = '';
  }
  searchType(event) {
    this.stype = event;
  }
  showOptions(event:MatCheckboxChange): void {
    this.isrecoveryDate =event.checked;
    
}
preventFilter(event){
  if (event.key === 'Enter') {
    event.preventDefault();
  }
}
  applyFilter(event: any) {
   if (event.key === 'Enter') {
    if(event.target.value.length >=3 ){
      this.helplistservice.getDiseaseData(event.target.value,this.stype).pipe(takeUntil(this.destroypast$)).subscribe((item:any)=>{
        
          this.dataSource.data =item.filter(item=>item.isActive ==true);
      
       }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
       });
    }
    }else{
   const finddata=this.filerdata(this.helplistservice.diseaseList.slice(),event.target.value);
    if(finddata.length >0){
     
        this.dataSource.data =finddata;
     
    }else{
      this.dataSource.data =[];
      this.masterdisesAraaydata =[];
      if(event.target.value.length >=3){
        if(event.target.value !=null && event.target.value !=''){
          var pdata= event.target.value;
        }else{
           pdata =0;
        }
        this.helplistservice.getDiseaseData(pdata,this.stype).pipe(takeUntil(this.destroypast$)).subscribe((item:any)=>{
       
           this.dataSource.data =item.filter(item=>item.isActive ==true);
        
        },err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      }
    }
  }
  }
  filerdata(items: any[], searchText: string){ 
    if(this.stype=='S'){
      return items ? items.filter(item => item.diseaseName?.toLowerCase().indexOf(searchText) === 0):[];
    }else{
      return items ? items.filter(item => item.diseaseName.search(new RegExp(searchText, 'i')) > -1) : [];
    }
}
preventFormSubmit(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
}
  // lengthbtn_clicked(itemindex: number, selectedval: number) {
  //   this.selectedButtonDuration = null;
  //   this.emrservice.pasthistory_added.startDate = null;
  //   this.selectedButton = itemindex;
  //   this.selectedButton_value = selectedval;
  //     for (let btn of this.lengthbuttons) {
  //       if (btn  = itemindex.toString()) {
  //         this.lengthbackground = "green";
  //       }
  //       else {
  //         this.lengthbackground = "white";
  //       }
  //    }
  // }
  clearselections(option: string) {
    this.selectedButton = null;
    this.selectedButtonDuration = null;
    if (option == "fromdate") {
    }
    else {
      this.dashboardService.selectedRowIndex = -1;
      this.emrservice.pasthistory_added.startDate = null;
      this.emrservice.pasthistory_added.recoveryOn = null;
      this.emrservice.pasthistory_added.remarks = '';
    }

  }



  // durationbutton_clicked(itemindex: number, btnclicked: string) {
  //   let todaysdate = new Date(this.authService.getServerDate);
  //   this.selectedButtonDuration = itemindex;
  //   if (btnclicked == "D") {
  //     this.emrservice.pasthistory_added.startDate =
  //       this.datePipe.transform(todaysdate.setDate(todaysdate.getDate() - this.selectedButton - 1), "yyyy-MM-dd");
  //   }
  //   if (btnclicked == "W") {

  //     const weekdays = (this.selectedButton + 1) * 7;

  //     this.emrservice.pasthistory_added.startDate =
  //       this.datePipe.transform(todaysdate.setDate(todaysdate.getDate() - weekdays), "yyyy-MM-dd");

  //   }
  //   if (btnclicked == "M") {
  //     this.emrservice.pasthistory_added.startDate =
  //       this.datePipe.transform(todaysdate.setMonth(todaysdate.getMonth() - this.selectedButton - 1), "yyyy-MM-dd");

  //   }
  //   if (btnclicked == "Y") {

  //     this.emrservice.pasthistory_added.startDate =
  //       this.datePipe.transform(todaysdate.setFullYear(todaysdate.getFullYear() - this.selectedButton - 1), "yyyy-MM-dd");

  //   }

  // }

  deletehistory(row: Object) {
    this.emrservice.delete_flag = "del_selected_disease";
    const dialogRef = this.dialog.open(Emr_delete_confirmation_boxComponent, {
      panelClass: 'full-width-dialog',
      width: 'auto',
      data: {}
    });
   dialogRef.afterClosed().pipe(takeUntil(this.destroypast$)).subscribe(result => {
      if (this.emrservice.delete_flag == "del_selected_disease") {
        const index: number = this.emrservice.pasthistory_client.indexOf(row);
        if (index !== -1) {
          this.emrservice.pasthistory_client.splice(index, 1);
          this.pasthistory_ds = new MatTableDataSource(this.emrservice.pasthistory_client.slice());
          this.emrservice.delete_flag = null;
        }
      }
    });


  }

  gettooltip(val: string) {
    if (val == "D") {
      return "Day";
    }
    if (val == "W") {
      return "Week";
    }
    if (val == "M") {
      return "Month";
    }
    if (val == "Y") {
      return "Year";
    }

  }



  addhistory(diseasename: string,event) {
   
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    },500);
    if (diseasename == undefined) {
      return this.dashboardService.openSnackBar("Please select at least one disease", "Ok");
    } else if (this.emrservice.pasthistory_added.startDate == undefined && diseasename.toLowerCase() != 'nil' && diseasename.toLowerCase() != 'nill' && diseasename.toLowerCase() != 'na') {
      this.durationvalue = 0;
      this.nextReviewUnit = 'D';
      return this.dashboardService.openSnackBar("Please add the disease start date", "Ok");
    } else if (
      Date.parse(this.emrservice.pasthistory_added.startDate) > Date.parse(this.emrservice.pasthistory_added.recoveryOn) &&
      diseasename.toLowerCase() != 'nil' &&
      diseasename.toLowerCase() != 'nill' &&
      diseasename.toLowerCase() != 'na' &&
      this.durationvalue !== "0"
    ) {
      this.nextReviewUnit = 'D';
      return this.dashboardService.openSnackBar("Start date and Recover on should be a past date or today", "Ok");
    } else if (this.isrecoveryDate == true && diseasename.toLowerCase() != 'nil' && diseasename.toLowerCase() != 'nill' && diseasename.toLowerCase() != 'na') {
      if (this.emrservice.pasthistory_added.recoveryOn == null || this.emrservice.pasthistory_added.recoveryOn == undefined) {
        return this.dashboardService.openSnackBar("RecoveryOn Date is Required", "Ok");
      }
    }
  
    this.setotherfields();
    for (let dis of this.emrservice.pasthistory_client) {
      if (dis.diseaseName.toLowerCase() == diseasename.toLowerCase()) {
        this.dashboardService.openSnackBar("Disease name " + diseasename + " already exists in the list", "OK");
        return;
      }
    }
  
    this.emrservice.get_pasthistory(this.emrservice.visitid).subscribe((apiResponse: any[]) => {
      const isDuplicateInApi = apiResponse.some((entry: any) => {
        return entry.diseaseName.toLowerCase() == diseasename.toLowerCase();
      });
  
      if (isDuplicateInApi) {
        this.dashboardService.openSnackBar("Disease name " + diseasename + " already exists in the list", "OK");
        return;
      }
  
      this.emrservice.pasthistory_added.diseaseName = diseasename;
      this.emrservice.pasthistory_client.unshift(this.emrservice.pasthistory_added);
      this.emrservice.pasthistory_added = {};
      this.pasthistory_ds = new MatTableDataSource(this.emrservice.pasthistory_client.slice());
      this.selectedButton = null;
      this.selectedButtonDuration = null;
      this.dashboardService.selectedRowIndex = -1;
      this.durationvalue = 0;
      this.nextReviewUnit = 'D';
    });
  }
  
  deleteall() {
    this.emrservice.delete_flag = "del_all_disease";
    const dialogRef = this.dialog.open(Emr_delete_confirmation_boxComponent, {
      panelClass: 'full-width-dialog',
      width: 'auto',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (this.emrservice.delete_flag == "del_all_disease") {
        this.pasthistory_ds = new MatTableDataSource(this.emrservice.pasthistory_client = []);
        this.emrservice.delete_flag = null;
      }
    });

  }
  setotherfields() {

    if (this.emrservice.pasthistory_added.startDate != null) {
      this.emrservice.pasthistory_added.startDate =
        this.datePipe.transform(this.emrservice.pasthistory_added.startDate, "MM-dd-yyyy").toString();
    }



    if (this.emrservice.pasthistory_added.recoveryOn != null) {
      this.emrservice.pasthistory_added.recoveryOn =
        this.datePipe.transform(this.emrservice.pasthistory_added.recoveryOn, "MM-dd-yyyy").toString();
    }
    // else {
    //   this.emrservice.pasthistory_added.recoveryOn = "Not Recovered Yet";
    // }

    this.emrservice.pasthistory_added.pkTranId = 0;
    this.emrservice.pasthistory_added.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.pasthistory_added.pkSynchId = null;
    this.emrservice.pasthistory_added.fkReg = null;
  }
  // applyFilter(filterValue: string) {
  //   this.disease_ds.filter = filterValue.trim().toLowerCase();
  // }


  closedialog() {

    this.dialogRef.close(0);

  }

  savehistory() {
    if (this.pasthistory_ds.data.length == 0) {
      this.dashboardService.openSnackBar("Please select at least one disease and disease start date before adding them to patient's past history", "Ok")
      return;
    }
    this.dialogRef.close(this.pasthistory_ds.data);
  }
  refReasonPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

     dialogRef.afterClosed().pipe(takeUntil(this.destroypast$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.emrservice.pasthistory_added.remarks = result;
        }

      }
    });
  }


  diseaseMaster() {
    this.Diseaseobject ={};
    this.Diseaseobject.pk_DiseaseId =0;
    this.Diseaseobject.seqNo=null;
    this.Diseaseobject.isEdit=false;
    document.getElementById("diseaseMasterModal").style.display = "block";
  }
  cancelDiseaseMaster() {
    document.getElementById("diseaseMasterModal").style.display = "none";
  }

  searchRecordDialogModal() {
    this.getdeseasedata(0,'A');
    document.getElementById("searchRecordDialogModal").style.display = "block";
  }
  cancelSearchRecordDialogModal() {
    this.SearchDisease ='';
    document.getElementById("searchRecordDialogModal").style.display = "none";
  }
  onReviewGrid(event: any, type) {
 
    switch (type) {
      case (1): {
        this.durationvalue = event;
        if (this.durationvalue > 0) {
          if (this.nextReviewUnit == 'D') {
            this.emrservice.pasthistory_added.startDate = null;
            var n4 = this.durationvalue;
            var today4 = new Date();
            var requiredDate4 = today4.setDate(today4.getDate() - Number(n4));
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate4, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'W') {
            this.emrservice.pasthistory_added.startDate = null;
            var n5 = this.durationvalue * 7;
            var today5 = new Date();
            var requiredDate5 = today5.setDate(today5.getDate() - Number(n5));
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate5, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'M') {
            this.emrservice.pasthistory_added.startDate = null;
            var n6 = this.durationvalue;
            var today6 = new Date();
            var requiredDate6 = new Date(today6.getFullYear(), today6.getMonth() - Number(n6), today6.getDate());
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate6, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'Y') {
            this.emrservice.pasthistory_added.startDate = null;
            var n7 = this.durationvalue;
            var today7 = new Date();
            var requiredDate7 = new Date(today7.getFullYear() - Number(n7), today7.getMonth(), today7.getDate());
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate7, 'yyyy-MM-dd');
          }
        } else {
          this.emrservice.pasthistory_added.startDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        }
        break;
      }
      case (2): {
        this.nextReviewUnit = event;
        if (this.durationvalue > 0) {
          if (this.nextReviewUnit == 'D') {
            this.emrservice.pasthistory_added.startDate = null;
            var n = this.durationvalue;
            var today = new Date();
            var requiredDate = today.setDate(today.getDate() - Number(n));
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'W') {
            this.emrservice.pasthistory_added.startDate = null;
            var n1 = this.durationvalue * 7;
            var today1 = new Date();
            var requiredDate1 = today1.setDate(today1.getDate() - Number(n1));
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate1, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'M') {
            this.emrservice.pasthistory_added.startDate = null;
            var n2 = this.durationvalue;
            var today2 = new Date();
            var requiredDate2 = new Date(today2.getFullYear(), today2.getMonth() - Number(n2), today2.getDate());
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate2, 'yyyy-MM-dd');
          } else if (this.nextReviewUnit == 'Y') {
            this.emrservice.pasthistory_added.startDate = null;
            var n3 = this.durationvalue;
            var today3 = new Date();
            var requiredDate3 = new Date(today3.getFullYear() - Number(n3), today3.getMonth(), today3.getDate());
            this.emrservice.pasthistory_added.startDate = this.datePipe.transform(requiredDate3, 'yyyy-MM-dd');
          }
        } else {
          this.emrservice.pasthistory_added.startDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        }
        break;
      }
      case (3): {
        this.durationvalue = this.calculateDiff(this.emrservice.pasthistory_added.startDate);

        if (this.durationvalue > 0) {
          if (this.nextReviewUnit == 'D') {
            this.durationvalue = this.calculateDiff(this.emrservice.pasthistory_added.startDate);
          } else if (this.nextReviewUnit == 'W') {
            if (this.durationvalue >= 7) {
              var weekdays = Math.floor(this.durationvalue / 7);
              this.durationvalue = weekdays;
            }
          } else if (this.nextReviewUnit == 'M') {
            this.durationvalue = this.monthDiff(new Date(), new Date(this.emrservice.pasthistory_added.startDate));

          } else if (this.nextReviewUnit == 'Y') {
            this.durationvalue = new Date(this.emrservice.pasthistory_added.startDate).getFullYear() - new Date().getFullYear();
          }
        }
        break;
      }

    }
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }
  calculateDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.abs( Math.floor((Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24)));
  }

  SelectDiease(rowdata){
  this.Diseaseobject={};
  this.Diseaseobject=rowdata;
  this.Diseaseobject.isEdit =true;
  this.cancelSearchRecordDialogModal();
  }
  saveDiease(event){
    if(event !=1){
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      setTimeout(function () {
        button.removeAttribute('disabled');
      }, 2000);
    }
    
    let chheckdublicate= this.masterdisesAraaydata.filter(item=>item.diseaseName?.toLowerCase() ==this.Diseaseobject.diseaseName.toLowerCase());
    if(chheckdublicate.length >0 && this.Diseaseobject.pk_DiseaseId ==0){
     return  this.dashboardService.openSnackBar("disease name " + this.Diseaseobject.diseaseName + " already exists", "OK");
    }
    let payload={"DiseaseMaster":this.Diseaseobject
  }
  this.emrservice.InsertDiseaseMaster(payload).pipe(takeUntil(this.destroypast$)).subscribe(item=>{
      this.getdeseasedata(0,0); 
      if(this.Diseaseobject.pk_DiseaseId ==0){
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      }else{
        this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
      }
      this.cancelDiseaseMaster();
      this.Diseaseobject={};
    },err=>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getdeseasedata(type,searchtype){
   this.helplistservice.getDiseaseData(type,searchtype).pipe(takeUntil(this.destroypast$)).subscribe((x:any)=>{
      this.masterdisesAraaydata =x;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  radioChange($event: MatRadioChange,row){
    this.Diseaseobject =row;
    this.Diseaseobject.isEdit =true;
    this.Diseaseobject.isDefault=$event.value;
   console.log($event.value);
   this.saveDiease(1);
  }
  apptexportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('contentapp');
    this.exportdata.Newexportxcel(element, 'Disease_List');
  }
  ngOnDestroy() {
    this.destroypast$.next(true);
    this.destroypast$.unsubscribe();
    this.todaysdate=null;
    this.Diseaseobject=null;
    this.displayedColumns = null;
    this.dataSource.data =null ;
    this.selectedrecoverydate =null;
    this.selectstaredate=null;
    this.durationvalue=null;
    this.nextReviewUnit=null;
    this.SearchDisease=null;
    this.Diseaseobject=null;
    this.masterdisesAraaydata=null;
    this.selectedButton=null;
    this.selectedButtonDuration=null;
    this.selectedButton_value=null;
    this.displayedColumns=null;
    this.emrservice.pasthistory_client=null;
  }

  onDiseaseNameInput(event: Event): void {
    const input = (event.target as HTMLInputElement).value;
    this.Diseaseobject.diseaseName = input.trim(); 
  }
  
  
}
